import { render, staticRenderFns } from "./custom-radio-button.vue?vue&type=template&id=11607ad0&scoped=true"
import script from "./custom-radio-button.vue?vue&type=script&lang=js"
export * from "./custom-radio-button.vue?vue&type=script&lang=js"
import style0 from "./custom-radio-button.vue?vue&type=style&index=0&id=11607ad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11607ad0",
  null
  
)

export default component.exports